import { LanguageActions, LanguageActionType } from 'app/core/language/state/actions';


export function languageReducer(state: {[key: string]: string} = {}, action: LanguageActions): {[key: string]: string} {
  switch (action.type) {

    // Handle retrieving a fresh load of languages
    case LanguageActionType.LoadLanguages:
    case LanguageActionType.LoadLanguagesFailed:
      return {
        ...state,
      };

    // Update the state when we get a new list of languages
    case LanguageActionType.LoadLanguagesCompleted:
      return { ...action.payload };

    default:
      return state;
  }
}
